<!-- Footer -->
<footer class="page-footer">

  <!-- Copyright -->
  <div class="text-center">
    <p style="color: slategrey">© 2018 Copyright: <strong>www.factor-based-investing.com</strong></p>
  </div>
  <!-- Copyright -->

</footer>
<!-- Footer -->
